import { Hyperlink } from "@Light/components/page/Hyperlink";
import { useScaffold } from "@Light/scaffold";
import { twMerge } from "tailwind-merge";

type PartnerTosDisclaimerProps = {
  className?: string;
};

export const PartnerTosDisclaimer: React.FC<PartnerTosDisclaimerProps> = ({
  className,
}) => {
  const scaffold = useScaffold();
  const partnerTosUrl = scaffold.page.termsOfServiceUrl;
  const partnerLegalName =
    scaffold.page.legalEntityName ?? scaffold.page.companyName;

  if (!partnerTosUrl) {
    return null;
  }

  return (
    <p
      className={twMerge(
        "text-xs text-balance",
        scaffold.page.colors.text.tertiary,
        className,
      )}
      data-testid="partner-tos-disclaimer"
    >
      By proceeding, you agree to {partnerLegalName}&rsquo;s{" "}
      <Hyperlink href={partnerTosUrl} target="_blank" rel="noopener noreferrer">
        Terms&nbsp;of&nbsp;Service
      </Hyperlink>
      .
    </p>
  );
};
